import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
  OnChanges,
} from '@angular/core';
import { FormGroup, ControlContainer } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DateService } from '../../services/date.service';
import { MessageService } from '../../services/message.service';
@Component({
  selector: 'app-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.css'],
})
export class TimepickerComponent implements OnInit, OnChanges {
  @ViewChild('timestart', { static: false }) start: ElementRef;
  @ViewChild('timeend', { static: false }) end: ElementRef;
  @Output() selectedTime: EventEmitter<any> = new EventEmitter<any>();
  public timeFormGroup: FormGroup;
  @Input() isDisabled = false;
  @Input() index = 0;
  @Input() currIndex = 0;
  @Input() hideAll = true;
  @Input() openByDefault = false;
  @Input() isCustomBtn = false;
  isSameDay: boolean = true;
  isBothTimeSelected: boolean = false;
  public showDropdown = false;
  timingError:boolean = false;
  constructor(
    private controlContainer: ControlContainer,
    private _dateService: DateService,
    private _msgService: MessageService,
    private _translateService: TranslateService
  ) {}

  ngOnInit() {
    this.timeFormGroup = <FormGroup>this.controlContainer.control;
    this.listenFormGroupChanges();
  }
  ngOnChanges() {
    if (this.openByDefault) {
      this.showDropdown = true;
    }
  }

  onSelectClick() {
    this.showDropdown = true;
  }

  onDoneClick() {
    if(this.timingError){
      return;
    }
    this.showDropdown = false;
    this.selectedTime.emit({
      start: this.timeFormGroup.get('time1').value,
      end: this.timeFormGroup.get('time2').value,
    });

    if (this.isCustomBtn && this.isBothTimeSelected) {
      const translatedMessage = this._translateService.instant(
        'CHANGES_WILL_REFLECT_ON_SAVING'
      );
      this._msgService.showSuccess(translatedMessage);
    }
  }

  listenFormGroupChanges(): void {
    // Subscribe to form group value changes
    this.timeFormGroup.valueChanges.subscribe(() => {
      this.updateIsSameDay();
    });
  }

  updateIsSameDay(): void {
    const startTime = this.timeFormGroup.get('time1').value;
    const endTime = this.timeFormGroup.get('time2').value;
    if (startTime && endTime) {
      this.isBothTimeSelected = true;
      this.isSameDay = this._dateService.areTimesOnSameDay(startTime, endTime);
    } else {
      this.isBothTimeSelected = false;
    }
  }

  showOnlyTime(time) {
    if (time === '' || time === null) return `  --:--  `;
    else {
      let d = new Date(time);
      let hour =
        d.getHours() == 0
          ? 12
          : d.getHours() > 12
          ? d.getHours() - 12
          : d.getHours();
      let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
      let hh = hour < 10 ? '0' + hour : hour;
      let ampm = d.getHours() < 12 ? 'AM' : 'PM';
      let format = hh + ':' + min + ' ' + ampm;
      return format;
    }
  }

  // Dynamically set [inputmode=none] when timepicker component is mounted
  onTimePickerChange(event, type) {
    if (event) {
      let el: any = document.getElementsByClassName(
        'ant-time-picker-panel-input'
      );
      setTimeout(() => {
        const node = [...el];
        node.forEach((elem) => elem.setAttribute('inputmode', 'none'));
      }, 0);
      // if(this[type].inputRef.nativeElement){
      //   setTimeout(()=>{
      //     this[type].inputRef.nativeElement.setAttribute("inputmode", "none");
      //   },500)
      // }
    }
  }

  onTimePickerValueChange(event){
    if(event){
      this.timingError = this.isEndTimeBeforeStartTime();
    }
  }

  // Checks if the selected end time is before the start time within the same AM/PM period.
  private isEndTimeBeforeStartTime(): boolean {
    if (!this.timeFormGroup) return false;
  
    const time1 = this.timeFormGroup.controls['time1']?.value;
    const time2 = this.timeFormGroup.controls['time2']?.value;
  
    if (!time1 || !time2) return false;
  
    const startDate = new Date(time1);
    const endDate = new Date(time2);
  
    const startTotalMinutes = startDate.getHours() * 60 + startDate.getMinutes();
    const endTotalMinutes = endDate.getHours() * 60 + endDate.getMinutes();
  
    const isSamePeriod = (startDate.getHours() >= 12) === (endDate.getHours() >= 12);
    const isEndBeforeStart = endTotalMinutes < startTotalMinutes;
  
    return isSamePeriod && isEndBeforeStart;
  }
}
